import styled from 'styled-components'

export const RecGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.9fr) minmax(0, 1fr);
  align-items: stretch;
  gap: 14px;
  height: calc(100vh - 130px);
  min-height: 520px;

  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 1fr);
    height: auto;
  }
`

export const RightCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
  min-height: 0;
`

/* coluna esquerda: Ajustes (3/4) em cima e Custo com Antecipações (1/4) embaixo */
export const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
  min-height: 0;
`

export const RecPanel = styled.div`
  background: #fff;
  border: 1px solid #e7e9ee;
  border-radius: 8px;
  overflow: hidden;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px -3px rgba(0, 0, 0, 0.15);

  /* dentro da coluna direita, CET e Detalhes dividem a altura igualmente */
  ${RightCol} > & {
    flex: 1;
  }
`

export const RecTitle = styled.div`
  text-align: center;
  font-size: 17px;
  color: #5a6069;
  padding: 12px 10px 10px;
`

export const TableScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 1000px) {
    flex: none;
    max-height: 400px;
  }
`
